<template>
  <el-pagination
    :background="background"
    :current-page.sync="currentPage"
    :page-size.sync="pageSize"
    :layout="layout"
    :page-sizes="pageSizes"
    :total="total"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
  >
    <div class="pagination-total">共{{sumCount}}条记录</div>
  </el-pagination>
</template>

<script>
export default {
  name: 'YhPagination',
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50];
      },
    },
    layout: {
      type: String,
      default: 'slot, prev, pager, next,jumper',
    },
    background: {
      type: Boolean,
      default: false,
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit('update:limit', val);
      },
    },
    sumCount() {
      return this.total;
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize });
    },
  },
};
</script>
<style lang="scss">
.pagination-total {
  display: inline-block;
  font-size: 14px;
  color: #606266;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  font-weight: 400;
  margin-right: 2em;
}
.el-pagination {
  text-align: right;
  padding-top: 20px;
}
</style>
